import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const certificatesUrl = `${SERVER_API}/users/certificates`;

export const CERTIFICATES = {
  ...generateCrudEndpoints(certificatesUrl),
  ME: {
    method: 'GET',
    url: `${certificatesUrl}/me`,
  } as IEndpointData,
  SIGN_FILE(id: number) {
    return {
      method: 'POST',
      url: `${certificatesUrl}/${id.toString()}/sign-file`,
    } as IEndpointData;
  },
};
